<template src='./massTaskModal.pug' lang='pug'></template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import ConfirmModal from '../../modals/confirmModal/ConfirmModal'
import Modal from '../../modals/modal/Modal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import language from '../../../../build/language/index.js'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import { maskThousand } from '../../../utils/numberMasker.js'
import { conciliationStatusTranslate, typeTranslate } from '../../../utils/statusesTranslator.js'
import customValidator from '../../../utils/customValidator.js'
import IdSituacaoTarefaEnum from '../../../enum/idSituacaoTarefa'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'MassTaskModal',

  components: {
    vSelect,
    Datepicker,
    ConfirmModal,
    Modal,
    ButtonPrimary
  },

  props: {
    id: {
      type: String,
      required: true
    },
    gridId: {
      type: String,
      required: true
    },
    listIdExt: {
      type: Array,
      required: true
    },
    listIdMov: {
      type: Array,
      required: true
    },
    listRows: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      tarefaStatuses: [
        {
          id: 0,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')
        },
        {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        {
          id: 20,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')
        }
      ],
      concilStatuses: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto')
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado')
        },
        {
          id: 'M',
          nome: this.$t('statusConciliacao.conciliadoManualmente')
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente')
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel')
        }
      ],
      concilStatusesTransformed: [],
      columns: [],
      options: {
        columnsClasses: {},
        headings: {},
        filterable: false,
        perPageValues: [],
        perPage: 5,
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: [],
        sortIcon: {
          is: ''
        }
      },
      items: [],
      task: {
        nome: '',
        tipoVinculo: '',
        descricao: '',
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        dtVencimento: new Date(),
        responsavel: null,
        conclusaoAutomatica: [],
        enviarEmail: false,
        idsMovimentosFinanceiros: [],
        idsContalancamento: []
      },
      message: null,
      invalid: false,
      toDate: new Date(),
      fromDate: new Date('December 31, 2999 23:59:59'),
      inputDate: null,
      isLoadingData: false,
      operators: [],
      hasAtLeastOneElegibleStatment: false,
      erroDataDeVencimento: false
    }
  },

  computed: {
    loggedUser () {
      return this.$store.getters.user
    },

    loggedUserEmail () {
      return this.$store.getters.userEmail
    },

    // retorna o idioma para o datepicker
    datePickerLanguage () {
      return language.getDatePickerLanguageObject()
    },

    modalTitle () {
      return this.$t('tarefaEmMassa.titulos.titulo')
    },

    modalSubtitle () {
      return this.$t('tarefaEmMassa.titulos.subtitulo')
    },

    portletTable () {
      return this.$t('tarefaEmMassa.titulos.portletTable')
    },

    portletForm () {
      return this.$t('tarefaEmMassa.titulos.portletForm')
    },

    messageEmail () {
      return this.$t('tarefaEmMassa.titulos.enviarEmail')
    },

    isSingleStatus () {
      // Retorna true caso todas as Situacoes do array 'items' sejam iguais
      return this.items.length > 0 && !!this.items.reduce((previous, atual) => (previous.Situacao === atual.Situacao) ? previous : NaN)
    },

    enableSave () {
      return this.hasAtLeastOneElegibleStatment && this.items.length > 0
    }
  },

  watch: {
    listRows () {
      this.erroDataDeVencimento = false
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.task = {
        nome: '',
        tipoVinculo: '',
        descricao: '',
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        dtVencimento: new Date(),
        responsavel: null,
        conclusaoAutomatica: [],
        enviarEmail: false,
        idsMovimentosFinanceiros: [],
        idsContalancamento: []
      }
      this.loadOperators()
    },

    items () {
      let noTaskStats = []
      this.items.forEach(item => {
        if (item.SituacaoTarefa === null) {
          noTaskStats.push(item)
        }
      })
      this.hasAtLeastOneElegibleStatment = noTaskStats.length > 0
    }
  },

  methods: {
    openModalConfirm () {
      $('#confirmMassTask').modal('show')
    },

    closeModalConfirm () {
      $('#confirmMassTask').modal('hide')
    },

    verifySave () {
      if (this.task.idsContalancamento &&
        this.task.idsContalancamento.length > 0 &&
        this.task.idsMovimentosFinanceiros &&
        this.task.idsMovimentosFinanceiros.length > 0
      ) {
        this.openModalConfirm()
      } else {
        this.validate()
      }
    },

    validate () {
      this.closeModalConfirm()
      this.isLoadingData = true
      this.$validator.validateAll().then((result) => {
        if (result && this.dataDeVencimentoValida()) {
          this.criatTarefaEmMAssa()
          this.$nextTick(() => {
            this.$validator.reset()
          })
        } else {
          this.isLoadingData = false
        }
      })
    },

    criatTarefaEmMAssa () {
      let massTask = {
        dataCriacao: new Date(),
        dataVencimento: this.task.dtVencimento,
        nome: this.task.nome,
        descricao: this.task.descricao,
        situacao: this.task.situacao.id,
        usuarioResponsavel: {
          idUsuario: this.task.responsavel.id
        },
        enviarEmail: this.task.enviarEmail,
        situacoesConclusaoAutomatica: [],
        idsMovimentosFinanceiros: this.task.idsMovimentosFinanceiros,
        idsContalancamento: this.task.idsContalancamento
      }

      this.task.conclusaoAutomatica.forEach(status => {
        massTask.situacoesConclusaoAutomatica.push(status.id)
      })

      this.$store.dispatch('createMassTask', massTask)
        .then((response) => {
          this.$root.$refs.notification.success(response.data.message)
          this.isLoadingData = false
          $('#' + this.id).modal('hide')
        })
        .catch((error) => {
          this.isLoadingData = false
          this.$root.$refs.notification.error(error.message)
        })
    },

    // evento para interação com o datepicker
    input () {
      this.dataDeVencimentoValida()
      this.validateDate()
    },

    // validação global do datepicker
    validateDate () {
      let isValid = this.inputDate.value.length === 10 &&
        customValidator.isValidDate(this.inputDate.value)
      if (!isValid) {
        this.task.dtVencimento = null
        this.$refs.dtVencimento.$children
          .find(item => !!item.id).typedDate = ''
      }
      return this.invalid
    },

    dataDeVencimentoValida () {
      if (this.task.dtVencimento) {
        let today = new Date()
        let yesterday = today.setDate(today.getDate() - 1)
        let validDate = false

        validDate = this.task.dtVencimento.getTime() > yesterday

        this.erroDataDeVencimento = !validDate

        return validDate
      }
      return true
    },

    trackCloseEvent () {
      this.$nextTick(() => {
        this.$validator.reset()
      })
      trackAnalyticsEvent(this, 'modal-mass-task', 'titlebar-close-click', this.id)
      $('#' + this.id).modal('hide')
    },

    showDataTable () {
      this.task.idsContalancamento = this.listIdExt
      this.task.idsMovimentosFinanceiros = this.listIdMov
      switch (this.gridId) {
        case 'ExtratoConta':
          this.task.tipoVinculo = {
            id: 'CL',
            descricao: this.$t('tarefaEmMassa.labels.tipoCl')
          }
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt)
            .then((response) => {
              this.mountDataTableBankStat(response)
            })
          break
        case 'RelatorioConciliacao':
          this.task.tipoVinculo = {
            id: 'RC',
            descricao: this.listIdExt.length > 0 ? this.$t('tarefaEmMassa.labels.tipoCl') +
              (this.listIdMov.length > 0 ? '/' + this.$t('tarefaEmMassa.labels.tipoMf') : '')
              : ''
          }
          this.task.tipoVinculo.id = 'RC'
          this.task.tipoVinculo.descricao = this.listIdExt.length > 0 && this.listIdMov.length > 0
          ? this.$t('tarefaEmMassa.labels.tipoCl') + '/' + this.$t('tarefaEmMassa.labels.tipoMf')
          : this.listIdExt.length > 0 && this.listIdMov.length === 0
          ? this.$t('tarefaEmMassa.labels.tipoCl')
          : this.listIdExt.length === 0 && this.listIdMov.length > 0
          ? this.$t('tarefaEmMassa.labels.tipoMf')
          : ' - '
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt.concat(this.listIdMov))
            .then((response) => {
              this.mountDataTableConcilReport(response)
            })
          break
        case 'MovimentoFinanceiro':
          this.task.tipoVinculo = {
            id: 'MF',
            descricao: this.$t('tarefaEmMassa.labels.tipoMf')
          }
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdMov)
            .then((response) => {
              this.mountDataTableMovFin(response)
            })
          break
      }

      // Verifica se o array de tarefas selecionados é de um mesmo status,
      // caso seja, remove essa opção selecionada das opçoes de conclusao automática
      if (this.isSingleStatus) {
        this.concilStatusesTransformed = this.concilStatuses.filter(status => status.nome !== this.items[0].Situacao)
      } else {
        this.concilStatusesTransformed = this.concilStatuses
      }
    },

    prepareList (movimentTasks) {
      this.items = []
      this.listRows.forEach(item => {
        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdLancamento) : null
        this.items.push({
          ID: item.IdLancamento,
          IdLancamento: item.IdLancamento,
          DtLanc: item.DtLanc ? moment.utc(item.DtLanc).format('l') : ' - ',
          Banco: item.Banco ? item.Banco : ' - ',
          NomeConta: item.NomeConta ? item.NomeConta : ' - ',
          Agencia: item.Agencia ? item.Agencia : ' - ',
          NrConta: item.NrConta ? item.NrConta : ' - ',
          Tipo: item.Tipo ? typeTranslate(item.Tipo, this) : ' - ',
          Valor: maskThousand(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),
          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        })
      })
    },

    removeEntry (entry) {
      let index = -1
      this.items.forEach(item => {
        if (item.ID === entry.ID) {
          index = this.items.indexOf(item)
        }
      })
      if (index >= 0) {
        this.items.splice(index, 1)
      }
      switch (this.gridId) {
        case 'ExtratoConta':
          let indexCL = this.task.idsContalancamento.findIndex(item => item === entry.ID)
          if (indexCL >= 0) {
            this.task.idsContalancamento.splice(indexCL, 1)
          }
          break
        case 'RelatorioConciliacao':
          if (entry.Tipo === this.$t('tarefaEmMassa.extrato.TipoMovBank')) {
            let indexCL = this.task.idsContalancamento.findIndex(item => item === entry.ID)
            if (indexCL >= 0) {
              this.task.idsContalancamento.splice(indexCL, 1)
            }
          } else if (entry.Tipo === this.$t('tarefaEmMassa.movimento.TipoMovFin')) {
            let indexMF = this.task.idsMovimentosFinanceiros.findIndex(item => item === entry.ID)
            if (indexMF >= 0) {
              this.task.idsMovimentosFinanceiros.splice(indexMF, 1)
            }
          }
          break
        case 'MovimentoFinanceiro':
          let indexMF = this.task.idsMovimentosFinanceiros.findIndex(item => item === entry.ID)
          if (indexMF >= 0) {
            this.task.idsMovimentosFinanceiros.splice(indexMF, 1)
          }
          break
      }
    },

    displayTaskAlert (item) {
      return item.SituacaoTarefa !== null
    },

    mountDataTableBankStat (response) {
      this.prepareList(response.data)
      this.columns = [
        'flag',
        'IdLancamento',
        'DtLanc',
        'Valor',
        'DsCategoria',
        'Banco',
        'NomeConta',
        'Agencia',
        'NrConta',
        'acoes'
      ]
      this.options.headings = {
        IdLancamento: this.$t('tarefaEmMassa.extrato.IdLancamento'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Banco: this.$t('tarefaEmMassa.extrato.Banco'),
        NomeConta: this.$t('tarefaEmMassa.extrato.NomeConta'),
        Agencia: this.$t('tarefaEmMassa.extrato.Agencia'),
        NrConta: this.$t('tarefaEmMassa.extrato.NrConta'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      }
      this.options.columnsClasses = {
        'IdLancamento': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Banco': 'col-1 limit-char',
        'NomeConta': 'col-1 limit-char',
        'Agencia': 'col-1 limit-char',
        'NrConta': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'DsCategoria': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      }
      this.options.orderBy = 'IdLancamento'
    },

    prepareListMovFin (movimentTasks) {
      this.items = []
      this.listRows.forEach(item => {
        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdMovimentacao) : null
        this.items.push({
          ID: item.IdMovimentacao,
          IdMov: item.IdMovimentacao,
          DtLanc: moment(item.DtLanc).format('l'),
          Tipo: item.Tipo ? typeTranslate(item.Tipo, this) : ' - ',
          Valor: maskThousand(item.VlLancamento),
          Estabelecimento: item.NomeEstabelecimento
            ? item.NomeEstabelecimento +
            (item.NomeEstabelecimentoGrupo ? ' - ' + item.NomeEstabelecimentoGrupo : '')
            : ' - ',
          PlanoConciliacao: item.NomePlanoConciliacao ? item.NomePlanoConciliacao : ' - ',
          Situacao: item.SituacaoConciliacao ? conciliationStatusTranslate(item.SituacaoConciliacao, this) : ' - ',
          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        })
      })
    },

    mountDataTableMovFin (response) {
      this.prepareListMovFin(response.data)
      this.columns = [
        'flag',
        'IdMov',
        'DtLanc',
        'Valor',
        'Estabelecimento',
        'PlanoConciliacao',
        'Situacao',
        'DsCategoria',
        'acoes'
      ]
      this.options.headings = {
        IdMov: this.$t('tarefaEmMassa.movimento.IdMov'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),
        PlanoConciliacao: this.$t('tarefaEmMassa.movimento.PlanoConcil'),
        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),
        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      }
      this.options.columnsClasses = {
        'IdMov': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Tipo': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'Estabelecimento': 'col-1 limit-char',
        'PlanoConciliacao': 'col-1 limit-char',
        'Situacao': 'col-1 limit-char',
        'DsCategoria': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      }
      this.options.orderBy = 'IdMov'
    },

    prepareConcilReport (movimentTasks) {
      this.items = []
      this.listRows.forEach(item => {
        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdMovFinanceiro || moviment.idVinculo === item.IdContaLancamento) : null
        this.items.push({
          ID: item.IdExtBancario ? item.IdExtBancario : item.IdMovFinanceiro,
          IdLote: item.IdConciliacaoLote ? item.IdConciliacaoLote : ' - ',
          Tipo: item.IdExtBancario
            ? this.$t('tarefaEmMassa.extrato.TipoMovBank')
            : this.$t('tarefaEmMassa.movimento.TipoMovFin'),
          DtLanc: moment(item.DataLancamento).format('l'),
          Valor: item.IdExtBancario ? maskThousand(item.ValorExtratoBancario) : maskThousand(item.ValorMovimentoFinanceiro),
          Estabelecimento: item.Estabelecimento
            ? item.Estabelecimento
            : ' - ',
          Situacao: item.FlagSituacaoConciliacao ? conciliationStatusTranslate(item.FlagSituacaoConciliacao, this) : ' - ',
          Ocorrencia: item.DescricaoMotivoOcorrenica,
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        })
      })
    },

    mountDataTableConcilReport (response) {
      this.prepareConcilReport(response.data)
      this.columns = [
        'flag',
        'IdLote',
        'Tipo',
        'DtLanc',
        'Valor',
        'Estabelecimento',
        'Situacao',
        'Ocorrencia',
        'acoes'
      ]
      this.options.headings = {
        IdLote: this.$t('tarefaEmMassa.ocorrencia.IdLote'),
        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),
        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),
        Ocorrencia: this.$t('tarefaEmMassa.ocorrencia.Ocorrencia'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      }
      this.options.columnsClasses = {
        'IdLote': 'col-1 limit-char',
        'Tipo': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'Estabelecimento': 'col-1 limit-char',
        'Situacao': 'col-1 limit-char',
        'Ocorrencia': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      }
      this.options.orderBy = 'IdLote'
    },

    loadOperators () {
      this.isLoadingData = true
      let url = 'operator'
      this.$store.dispatch('getOperators', url).then((response) => {
        this.operators = response.data
        this.operators.forEach(op => {
          if (op.email === this.loggedUserEmail) {
            this.task.responsavel = op
          }
        })
        if (!this.task.responsavel) {
          this.task.responsavel = this.operators[0]
        }
        this.showDataTable()
        this.isLoadingData = false
      })
    },

    alertTooltipMessage (item) {
      let message = ''

      switch (item.SituacaoTarefa) {
        case IdSituacaoTarefaEnum.PENDENTE:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.pendente')
          break
        case IdSituacaoTarefaEnum.EM_ANDAMENTO:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.emAndamento')
          break
        case IdSituacaoTarefaEnum.AGUARDANDO:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.aguardando')
          break
      }

      return this.$t('tarefaEmMassa.labels.itemVinculado') + message
    }
  },

  mounted () {
    this.erroDataDeVencimento = false
    this.inputDate = document.getElementById('dtVencimento')
    if (this.inputDate) {
      this.inputDate.setAttribute('autocomplete', 'off')
      this.inputDate.addEventListener('blur', () => {
        this.validateDate()
      })
    }
  }
}
</script>

<style lang='css' scoped>
.task-title {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #fff;
  color: #1b3c65;
  padding: 0px 0px 5px 15px;
  font-size: 15px;
}

.enviar-e-mail-automa {
  font-size: 11px !important;
  text-align: left;
  color: #2a2a2a;
  text-transform: initial !important;
}

.input-date-picker {
  border: none;
  width: 80%;
}

.form-control[disabled], fieldset[disabled] .form-control {
  cursor: not-allowed;
  font-weight: bold;
  color: #626262;
}
</style>



// WEBPACK FOOTER //
// MassTaskModal.vue?7ae27943